<div class="list-toolbar">
  <button mat-flat-button type="button" color="primary" (click)="createRoleWithAi()" [disabled]="loading">
    Create Role via AI
  </button>
</div>

<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<app-career-role-list
  [items]="roleItems"
  [totalCount]="roleListCount"
  [loading]="loading"
  [compact]="true"
  (load)="loadRoles($event)"
  (openRole)="openRole($event)">
</app-career-role-list>
